import { Check } from 'lucide-react';
import { ArenaCard } from 'modules/jogador/home/components/ArenaCard';
import { toFeaturedArena } from 'modules/jogador/home/arenaSearchService';
import { DEFAULT_ARENA_PROFILE } from 'shared/contexts/ArenaProfileContext';
import { SAAS_PLANS } from 'modules/arena/onboarding/content';
import { ArenaOnboardingState } from 'modules/arena/onboarding/useArenaOnboarding';

// Prévia ao vivo: o card do marketplace como o jogador vai ver, atualizado a cada tecla.
// Usa o mesmo ArenaCard da home, então a prévia é fiel ao que vai ao ar.
export function ArenaLivePreview({ state }: { state: ArenaOnboardingState }) {
  const namedCourts = state.courts.filter((court) => court.name.trim());
  const plan = SAAS_PLANS.find((item) => item.id === state.planId);
  const card = toFeaturedArena({
    ...DEFAULT_ARENA_PROFILE,
    arenaName: state.arenaName.trim() || 'Sua arena',
    unitName: state.unitName.trim() || 'Unidade Principal',
    address: state.address.trim(),
    city: state.city,
    sports: state.selectedSportIds,
    courts: namedCourts.length ? namedCourts : state.courts,
  });

  // `step`: índice da etapa que define o item. O check verde só aparece depois que a pessoa
  // passou por ela; antes disso o valor é o padrão e aparece apagado (cinza, check vazio).
  const summary = [
    { step: 1, label: 'Esportes', value: state.selectedSportIds.join(', ') || '—' },
    { step: 2, label: 'Quadras', value: namedCourts.length ? `${namedCourts.length} cadastrada${namedCourts.length > 1 ? 's' : ''}` : '—' },
    { step: 3, label: 'Funcionamento', value: `${state.openDays.length} dias · ${state.openTime}–${state.closeTime}` },
    { step: 4, label: 'Equipe', value: state.team.length ? `${state.team.length} pessoa${state.team.length > 1 ? 's' : ''}` : 'Só você' },
    { step: 6, label: 'Plano', value: plan ? `${plan.name} · R$ ${plan.price}/mês` : '—' },
  ].map((item) => ({ ...item, confirmed: state.stepIndex > item.step }));

  return (
    <div className="flex flex-col gap-5">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">Como os jogadores vão ver</p>
        <div className="pointer-events-none mt-3" aria-label="Prévia do card da sua arena no marketplace">
          <ArenaCard arena={card} />
        </div>
      </div>

      <div className="rounded-2xl border border-border/60 bg-surface p-5">
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">Resumo até aqui</p>
        <dl className="mt-3 flex flex-col gap-2.5 text-sm">
          {summary.map((item) => (
            <div key={item.label} className="flex items-start justify-between gap-4">
              <dt className="flex items-center gap-1.5 text-ink-secondary">
                <Check
                  className={item.confirmed ? 'h-3.5 w-3.5 text-success' : 'h-3.5 w-3.5 text-border'}
                  strokeWidth={2.5}
                  aria-label={item.confirmed ? 'definido' : 'ainda não definido'}
                />
                {item.label}
              </dt>
              <dd className={item.confirmed ? 'whitespace-nowrap text-right font-medium text-ink' : 'whitespace-nowrap text-right text-ink-secondary/70'}>
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
